// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicarePlanTypeResponseModel {
    'name'?: string;
    'states'?: Array<string>;
    'covered'?: string;
    'priorAuthorization'?: string;
    'lineOfBusiness'?: string;
    'drugCode'?: string;
    'coverageCriteria'?: string;
    'administrationCode'?: string;
    'buyAndBill'?: string;
    'administrationCovered'?: string;
    'freeTextPriorAuthorization'?: string;
    'fdaLabelIndications'?: string;
    'lastDayReviewed'?: string;
    'billingNotes'?: string;
    'deductible'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicarePlanTypeResponseModel>> = [
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "states",
            "baseName": "states",
            "type":     "Array<string>"
        },
        {
            "name":     "covered",
            "baseName": "covered",
            "type":     "string"
        },
        {
            "name":     "priorAuthorization",
            "baseName": "priorAuthorization",
            "type":     "string"
        },
        {
            "name":     "lineOfBusiness",
            "baseName": "lineOfBusiness",
            "type":     "string"
        },
        {
            "name":     "drugCode",
            "baseName": "drugCode",
            "type":     "string"
        },
        {
            "name":     "coverageCriteria",
            "baseName": "coverageCriteria",
            "type":     "string"
        },
        {
            "name":     "administrationCode",
            "baseName": "administrationCode",
            "type":     "string"
        },
        {
            "name":     "buyAndBill",
            "baseName": "buyAndBill",
            "type":     "string"
        },
        {
            "name":     "administrationCovered",
            "baseName": "administrationCovered",
            "type":     "string"
        },
        {
            "name":     "freeTextPriorAuthorization",
            "baseName": "freeTextPriorAuthorization",
            "type":     "string"
        },
        {
            "name":     "fdaLabelIndications",
            "baseName": "fdaLabelIndications",
            "type":     "string"
        },
        {
            "name":     "lastDayReviewed",
            "baseName": "lastDayReviewed",
            "type":     "string"
        },
        {
            "name":     "billingNotes",
            "baseName": "billingNotes",
            "type":     "string"
        },
        {
            "name":     "deductible",
            "baseName": "deductible",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicarePlanTypeResponseModel.attributeTypeMap;
    }
}
